import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import { Button, Table } from '@ipc/ipc-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import checkboxHOC from 'react-table/lib/hoc/selectTable';
import Scrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import classNames from 'classnames';
import {
  clearTableSelection,
  tableCheckItemsSetSuccess,
  tableFilteredDataSetSuccess,
  tableToggleAll,
  tableToggleSelection,
} from './actions/ListTableActions';
import DownloadTypes from './excel/DownloadTypes';
import downloadTableAsXlsx from './excel/downloadTable';
import TableDefinitions from '../TableDefinitions';
import {
  getSelectAll,
  getSelection,
  getSelectedRows,
} from './selectors/ListTableSelector';

const CheckboxTable = checkboxHOC(Table);

const paginationMapper = [];

export class ListTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: {},
      filtered: [],
      page: 0,
    };
    this.changePage = this.changePage.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if ((this.props.pagination && (prevProps.loading !== this.props.loading) && !_.isEqual(prevProps.data, this.props.data))
      || (!_.isEqual(prevState.filtered, this.state.filtered))) {
      /* eslint-disable react/no-did-update-set-state */
      this.setState({
        page: 0,
      });
      if (this.props.pagination) {
        const elementNext = document.querySelector('div[class="-next"]').firstChild;
        const elementPrevious = document.querySelector('div[class="-previous"]').firstChild;
        elementPrevious.click();
        elementNext.click();
      }
    }
    if ((prevProps.listId === this.props.listId) && !_.isEqual(prevProps.data, this.props.data)) {
      /* eslint-disable react/no-did-update-set-state */
      this.setState({
        filtered: [],
        page: 0,
      });
    }
  }

  CustomTbodyComponent = (props) => (
    <div {...props} className={classNames('rt-tbody', props.className || [])}>
      <Scrollbar>{props.children}</Scrollbar>
    </div>
  );

  toggleSelection = (key, shift, row) => {
    const { selection: prevSelection, checkboxSelectedRows } = this.props;
    let selection = [...prevSelection];
    let selectedRows = [...checkboxSelectedRows];
    const keyIndex = selection.indexOf(key);
    if (keyIndex >= 0 && this.isRowCheckboxSelected(row)) {
      selection = [
        ...selection.slice(0, keyIndex),
        ...selection.slice(keyIndex + 1),
      ];
      selectedRows = [
        ...selectedRows.slice(0, keyIndex),
        ...selectedRows.slice(keyIndex + 1),
      ];
    } else if (!this.isRowCheckboxSelected(row)) {
      selection.push(key);
      selectedRows.push(row);
    }
    this.props.tableToggleSelection({
      selection,
      selectedRows,
      tableDefinition: TableDefinitions[this.props.listId],
    });
  };

  toggleAll = () => {
    const { selectAll: prevSelectAll } = this.props;
    const selectAll = !prevSelectAll;
    const selection = [];
    const selectedRows = [];
    const currentRecords = this.props.data;
    const downloadableData = this.visibleData;
    if (selectAll && downloadableData !== undefined && downloadableData.length !== 0) {
      downloadableData.forEach((item) => {
        // eslint-disable-next-line no-underscore-dangle
        selection.push(`select-${item._original[this.props.keyField]}`);
        // eslint-disable-next-line no-underscore-dangle
        selectedRows.push(item._original);
      });
    } else if (selectAll) {
      currentRecords.forEach((item) => {
        selection.push(`select-${item[this.props.keyField]}`);
        selectedRows.push(item);
      });
    }
    this.props.tableToggleAll({
      selection,
      selectedRows,
      selectAll,
      tableDefinition: TableDefinitions[this.props.listId],
    });
    this.setState({
      expanded: {},
    });
  };

  isSelected = (key) => this.props.selection.includes(`select-${key}`);

  isRowCheckboxSelected = (row) => this.props.checkboxSelectedRows.includes(row);

  downloadTable = () => {
    const listId = TableDefinitions[this.props.listId].id;
    const downloadFileName = this.props.downloadFileAs ? this.props.downloadFileAs : listId;
    const templateFile = this.props.downloadFileTemplate ? this.props.downloadFileTemplate : listId;
    const additionalColumnGenerator = this.props.downloadAdditionalRowGenerator ? this.props.downloadAdditionalRowGenerator : undefined;
    const { checkboxSelectedRows } = this.props;

    let dataSource = checkboxSelectedRows;
    const downloadableData = this.visibleData;
    let { columns } = this.props.columns[0].columns.length !== 1 ? this.props.columns[0] : { Header: '', columns: this.props.columns.reduce((arr, elem) => [...arr, ...elem.columns], []) };

    if (additionalColumnGenerator) {
      dataSource = [...checkboxSelectedRows].reduce((accumulatedNewDataSource, row, index) => {
        const additionalColumnsData = additionalColumnGenerator(row, index);
        const newDataSource = {
          ...additionalColumnsData,
          ...row,
        };

        return [
          ...accumulatedNewDataSource,
          newDataSource,
        ];
      }, []);

      columns = columns.concat(this.props.columns[0].columnsOnDownload);
    }

    const downloadableSortedData = [];
    downloadableData.forEach((row) => {
      dataSource.forEach((selectedRow) => {
        // eslint-disable-next-line no-underscore-dangle
        if (selectedRow === row._original) {
          downloadableSortedData.push(selectedRow);
        }
      });
    });

    downloadTableAsXlsx(this.props.checkboxSelectedRows.length !== this.props.data.length ? downloadableSortedData : dataSource, columns, templateFile, downloadFileName);
  };

  onExpandedChange = (newExpanded, index) => {
    this.setState({
      expanded: { [index]: newExpanded[index] },
    });
  }

  onFilteredChange = (filtered) => {
    this.setState({
      filtered,
    });
    this.changePage(0);
    if (this.visibleData !== undefined) {
      // eslint-disable-next-line no-underscore-dangle
      const newVisibleData = this.visibleData.map((index) => index._original);
      this.props.tableFilteredDataSetSuccess({ tableId: this.props.listId }, newVisibleData);
    } else {
      this.props.tableFilteredDataSetSuccess({ tableId: this.props.listId }, this.props.data);
    }
    this.props.clearTableSelection({ tableDefinition: TableDefinitions[this.props.listId] });
  }

  onPageSizeChange = () => {
    this.changePage(0);
  }

  reactTableRef = (ELEMENT_REF) => {
    this.reactTableElement = ELEMENT_REF;
  };

  changePage(pageIndex) {
    this.setState({
      page: pageIndex,
    });
    paginationMapper[this.props.listId] = pageIndex;
    if (paginationMapper[this.props.listId] === null) {
      this.setState({
        page: 0,
      });
      paginationMapper[this.props.listId] = pageIndex;
    } else {
      this.setState({
        page: paginationMapper[this.props.listId],
      });
    }
  }

  render() {
    const {
      page,
    } = this.state;
    const {
      toggleSelection,
      toggleAll,
      isSelected,
    } = this;
    const { selectAll } = this.props;

    const checkboxProps = {
      selectAll,
      isSelected,
      toggleSelection,
      toggleAll,
      selectType: 'checkbox',
    };
    const {
      columns,
      data,
      getTrProps,
      getTdProps,
      getSubComponentProps,
      pagination,
      downloadType = DownloadTypes.NONE,
    } = this.props;

    const hasColumns = !!(columns && columns.length);
    const isDisabledDownload = () => data.length === 0 || this.props.checkboxSelectedRows.length === 0;
    return (
      <div className="list-wrapper">
        <section className="generated-list">
          {downloadType !== DownloadTypes.NONE && (
            <div>
              <Button
                disabled={isDisabledDownload()}
                className={`primary-button-${isDisabledDownload()} download-action-buttons`}
                onClick={this.downloadTable}
              >
                DOWNLOAD
              </Button>
            </div>
          )}
          {hasColumns && !pagination && (
            <div className="generated-list__table-wrapper">
              {!this.props.selectCheckbox
              && (
                <Table
                  ref={(instance) => { this.reactTable = instance; }}
                  loading={this.props.loading}
                  noDataText={this.props.loading ? '' : 'No history for the current selection.'}
                  data={data}
                  columns={columns}
                  TbodyComponent={this.CustomTbodyComponent}
                  pageSize={data.length}
                  getTrProps={getTrProps}
                  getTdProps={getTdProps}
                  onFilteredChange={(filtered) => this.onFilteredChange(filtered)}
                  filtered={this.state.filtered}
                  showPagination={false}
                  striped
                  highlight
                  className="-highlight"
                  onExpandedChange={this.onExpandedChange}
                  expanded={this.state.expanded}
                />
              )}
              {this.props.selectCheckbox
              && (
                <CheckboxTable
                  ref={(r) => { this.checkboxTable = r; }}
                  loading={this.props.loading}
                  noDataText={this.props.loading ? '' : 'No results for the current selection.'}
                  data={data}
                  columns={columns}
                  TbodyComponent={this.CustomTbodyComponent}
                  pageSize={data.length}
                  showPagination={false}
                  onFilteredChange={(filtered) => this.onFilteredChange(filtered)}
                  filtered={this.state.filtered}
                  striped
                  highlight
                  className="-highlight"
                  keyField={this.props.keyField}
                  getTrProps={getTrProps}
                  getTdProps={getTdProps}
                  SubComponent={getSubComponentProps}
                  onExpandedChange={this.onExpandedChange}
                  expanded={this.state.expanded}
                  {...checkboxProps}
                >
                  {(state, makeTable) => {
                    this.visibleData = [...state.sortedData];
                    return makeTable();
                  }}
                </CheckboxTable>
              )}
            </div>
          )}
          {hasColumns && pagination && (
            <div className="generated-list__table-wrapper">
              {!this.props.selectCheckbox
              && (
                <Table
                  ref={(instance) => { this.reactTable = instance; }}
                  loading={this.props.loading}
                  noDataText={this.props.loading ? '' : 'No results for the current selection.'}
                  data={data}
                  columns={columns}
                  TbodyComponent={this.CustomTbodyComponent}
                  getTrProps={getTrProps}
                  getTdProps={getTdProps}
                  page={page === -1 ? 0 : page}
                  onPageChange={(pageIndex) => this.changePage(pageIndex)}
                  onFilteredChange={(filtered) => this.onFilteredChange(filtered)}
                  onPageSizeChange={this.onPageSizeChange}
                  filtered={this.state.filtered}
                  showPagination={pagination}
                  pageSizeOptions={[5, 10, 15, 25, 50, 100]}
                  defaultPageSize={100}
                  minRows={0}
                  striped
                  highlight
                  className="-highlight"
                  onExpandedChange={this.onExpandedChange}
                  expanded={this.state.expanded}
                  style={{ maxHeight: '750px' }}
                />
              )}
              {this.props.selectCheckbox
              && (
                <CheckboxTable
                  ref={(r) => { this.checkboxTable = r; }}
                  loading={this.props.loading}
                  noDataText={this.props.loading ? '' : 'No results for the current selection.'}
                  TbodyComponent={this.CustomTbodyComponent}
                  data={data}
                  columns={columns}
                  page={page === -1 ? 0 : page}
                  onPageChange={(pageIndex) => this.changePage(pageIndex)}
                  onFilteredChange={(filtered) => this.onFilteredChange(filtered)}
                  filtered={this.state.filtered}
                  onPageSizeChange={this.onPageSizeChange}
                  showPagination={pagination}
                  pageSizeOptions={[5, 10, 15, 25, 50, 100]}
                  defaultPageSize={100}
                  minRows={0}
                  striped
                  highlight
                  className="-highlight"
                  keyField={this.props.keyField}
                  getTrProps={getTrProps}
                  getTdProps={getTdProps}
                  SubComponent={getSubComponentProps}
                  onExpandedChange={this.onExpandedChange}
                  expanded={this.state.expanded}
                  style={{ maxHeight: '750px' }}
                  {...checkboxProps}
                >
                  {(state, makeTable) => {
                    this.visibleData = [...state.sortedData];
                    return makeTable();
                  }}
                </CheckboxTable>
              )}
            </div>
          )}
        </section>
      </div>
    );
  }
}

ListTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
  checkboxSelectedRows: PropTypes.arrayOf(PropTypes.object),
  selectAll: PropTypes.bool.isRequired,
  data: PropTypes.arrayOf(PropTypes.object),
  selectCheckbox: PropTypes.bool,
  keyField: PropTypes.string,
  title: PropTypes.string,
  selection: PropTypes.arrayOf(PropTypes.string).isRequired,
  tableCheckItemsSetSuccess: PropTypes.func,
  tableFilteredDataSetSuccess: PropTypes.func,
  listId: PropTypes.string,
  children: PropTypes.objectOf(PropTypes.shape),
  getTrProps: PropTypes.func,
  getTdProps: PropTypes.func,
  tableToggleAll: PropTypes.func.isRequired,
  tableToggleSelection: PropTypes.func.isRequired,
  getSubComponentProps: PropTypes.func,
  downloadType: PropTypes.string,
  loading: PropTypes.bool,
  downloadFileAs: PropTypes.string,
  downloadFileTemplate: PropTypes.string,
  downloadAdditionalRowGenerator: PropTypes.func,
  pagination: PropTypes.bool,
  clearTableSelection: PropTypes.func,
};

const mapStateToProps = (state, props) => ({
  selectAll: getSelectAll(state, props),
  selection: getSelection(state, props),
  checkboxSelectedRows: getSelectedRows(state, props),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableCheckItemsSetSuccess,
  tableToggleAll,
  tableToggleSelection,
  tableFilteredDataSetSuccess,
  clearTableSelection,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ListTable);
